module.exports = __webpack_public_path__ + "img/magicians broom.023c8b4b.png";